export default __webpack_public_path__ + "images/19_2_image.jpg";